module.exports = __webpack_public_path__ + "img/code.da6fe36e.png";